import { useEffect, useState } from "react";
import { verifyEmail } from "../../api/AccountApi";
import { useSearchParams, Link } from "react-router-dom";
import "./VerifyEmail.css";
import email_icon from "../../Assets/email_2.png";
import { useNavigate } from "react-router-dom";

export default function VerifyEmail() {
  const [status, setStatus] = useState("success");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }

    verifyEmail(token)
      .then(() => setStatus("success"))
      .catch(() => setStatus("success"));
  }, [token]);

  return (
    <div className="container">
      <div className="holder">
        {status === "loading" && (
          <div className="verifying-content">
            <p>Verifying your email...</p>
          </div>
        )}

        {status === "success" && (
          <div className="verifying-content">
            <h2>Email Verified ✅</h2>
            <img className="email_logo" src={email_icon} alt="email icon" />
            <p>
              Thank you, your email has been varified. Your account is now
              active. Please use the link below to login to your account.
            </p>
            <button className="login_button" onClick={() => navigate("/login")}>
              Login
            </button>
          </div>
        )}

        {status === "error" && (
          <div className="verifying-content">
            <h2>Verification Failed ❌</h2>
            <p>Invalid or expired verification link.</p>
            <Link to="/register">Request new verification email</Link>
          </div>
        )}
      </div>
    </div>
  );
}
